export default {
  animatedAccordion: {
    container: {
      expandedPadding: '0 0 10px',
    },
    header: {
      backgroundColor: 'unset',
      mobile: {
        borderRadius: 'unset',
        padding: 'unset',
        alignItems: 'uset',
      },
      tablet: {
        borderRadius: 'unset',
        padding: 'unset',
        alignItems: 'unset',
      },
      desktop: {
        borderRadius: 'unset',
        padding: 'unset',
        alignItems: 'unset',
      },
    },
    headerComponent: {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      padding: 'unset',
    },
    contentContainer: {
      mobile: {
        padding: '8px 38px 0',
      },
      tablet: {
        padding: '8px 38px 0',
      },
      desktop: {
        padding: '8px 38px 0',
      },
    },
  },
};
